import React from 'react';
import support from '../Components/images/support.png'

const Support = () => {
    return(
        <div>
            <img src={support} className='homeImg' alt='homepage'/>
        </div>
    )
}

export default Support;